import React from "react";
import {
    Button,
    ButtonGroup,
} from "@mui/material";
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(() => ({
    button: {
        backgroundColor: '#5c45c7',
        color: 'white',
        '&:hover': {
            backgroundColor: '#150950'
        }
    },
}));

const ButtonAnswer = ({ options, answer, setAnswer }) => {
    const { classes } = useStyles();    

    return (
        <ButtonGroup fullWidth>
            {options.map(o =>
                <Button
                    className={answer === o ? classes.button : undefined}
                    variant={answer === o ? "contained" : "outlined"}
                    key={o} onClick={() => setAnswer(o)}>
                {o}
            </Button>
            )}
        </ButtonGroup>
    );
};

export default ButtonAnswer;
